import React from "react";
import "../styles/_navbar.scss";
interface Props {}

const NavbarGR: React.FC<Props> = (props) => {
  return (
    <nav className="navbar navbar-expand-lg ">
      <div className="container navMenu flex-lg-column flex-xl-row">
        <img src="LogoAlMare.png" alt="" className="logoAlMare py-4" />
        <button
          className="navbar-toggler ms-auto"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div
          className="collapse navbar-collapse flex-lg-column flex-xl-row"
          id="navbarSupportedContent"
        >
          <ul className="navbar-nav  ms-auto me-auto me-xl-0 mb-2 mb-lg-0">
            <li className="nav-item myBorder">
              <a className="nav-link" aria-current="page" href="#">
                Σπίτι
              </a>
            </li>
            <li className="nav-item myBorder">
              <a className="nav-link " href="#theHotel">
                ΤΟ ΞΕΝΟΔΟΧΕΙΟ
              </a>
            </li>
            <li className="nav-item myBorder">
              <a className="nav-link " href="#accomodation">
                Κατάλυμα
              </a>
            </li>
            <li className="nav-item myBorder">
              <a className="nav-link" href="#gallery">
                ΕΚΘΕΣΙΑΚΟΣ ΧΩΡΟΣ
              </a>
            </li>
            <li className="nav-item myBorder">
              <a className="nav-link" href="#contents">
                Περιεχόμενα
              </a>
            </li>
            <li className="nav-item myBorder">
              <a className="nav-link" href="#price">
                τιμές
              </a>
            </li>
            <li className="nav-item lastItem">
              <a className="nav-link" href="#contactUs">
                επαφή
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default NavbarGR;
